export default function DataDeletionPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-sm border border-gray-100 p-8 space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Data Deletion Request</h1>
          <p className="text-gray-500 text-sm mt-1">Gympe Member App — Account & Data Removal</p>
        </div>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-gray-800">How to request deletion</h2>
          <p className="text-sm text-gray-600 leading-relaxed">
            You can request the permanent deletion of your Gympe account and all associated personal data directly from within the app:
          </p>
          <ol className="list-decimal list-inside text-sm text-gray-600 space-y-1 pl-2">
            <li>Open the Gympe Member App and log in.</li>
            <li>Go to <strong>Profile</strong> (bottom navigation).</li>
            <li>Scroll to the <strong>Privacy</strong> section.</li>
            <li>Tap <strong>Delete My Account &amp; Data</strong> and confirm.</li>
          </ol>
          <p className="text-sm text-gray-600 leading-relaxed">
            Your request will be reviewed and processed within <strong>24–48 hours</strong>.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-gray-800">What data is deleted</h2>
          <ul className="list-disc list-inside text-sm text-gray-600 space-y-1 pl-2">
            <li>Your name, phone number, and email address</li>
            <li>Health profile (height, weight, medical notes)</li>
            <li>Progress photos and fitness reports</li>
            <li>Class bookings and waitlist entries</li>
            <li>Gym membership and check-in history (anonymised)</li>
            <li>Login sessions and refresh tokens</li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-gray-800">What is retained</h2>
          <p className="text-sm text-gray-600 leading-relaxed">
            Financial transaction records (invoices, payment amounts) may be retained in anonymised form for legal and accounting compliance. These records will no longer be linked to your personal identity.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-gray-800">Contact</h2>
          <p className="text-sm text-gray-600 leading-relaxed">
            If you are unable to access the app, email us at{' '}
            <a href="mailto:privacy@gympe.in" className="text-indigo-600 underline">privacy@gympe.in</a>{' '}
            with your registered phone number and we will process your request manually.
          </p>
        </section>

        <p className="text-xs text-gray-400 border-t border-gray-100 pt-4">
          Last updated: April 2026 · Gympe
        </p>
      </div>
    </div>
  );
}
